import CustomReactSelect from "../../CustomReactSelect";
import ModalService from "../../ModalService";
import * as formRicercaStyles from "../form-ricerca.module.scss";
import * as inputsStyles from "./inputs.module.scss";
import classNames from "classnames";
import { graphql, useStaticQuery } from "gatsby";
import parse from "html-react-parser";
import React, { useEffect, useState } from "react";

// Fonte unica delle opzioni della classe energetica: usata sia da questo input
// del ricercatore sia dai tool WebMCP (src/webmcp/ricercaFieldRules.js), cosi` un
// aggiornamento qui si riflette automaticamente sulle choices esposte all'agent.
export const classeEnergeticaOptions = [
  { value: "A", label: "A" },
  { value: "B", label: "B" },
  { value: "C", label: "C" },
  { value: "D", label: "D" },
  { value: "E", label: "E" },
  { value: "F", label: "F o inferiore" },
  { value: "", label: "Non lo so" },
];

const options = classeEnergeticaOptions;

const ClasseEnergetica = ({
  value,
  handler,
  type,
  className,
  selectCustom,
  fromRicerca = false,
}) => {
  const [showModalService, setShowModalService] = useState(false);
  const [fieldValue, setFieldValue] = useState(
    options.find((o) => o.value === value)
  );
  const handleChange = (selectedOption) => {
    setFieldValue(selectedOption);
    handler("ClasseEnergetica", selectedOption.value);
  };
  useEffect(() => {
    setFieldValue(options.find((o) => o.value === value));
  }, [value]);

  const {
    wp: {
      acfOptionsRicercatoreMutui: {
        acfRicercatoreMutui: {
          impostazioniGlobali: { testiInformazioni },
        },
      },
    },
  } = useStaticQuery(graphql`
    query {
      wp {
        acfOptionsRicercatoreMutui {
          acfRicercatoreMutui {
            impostazioniGlobali {
              testiInformazioni {
                classeEnergeticaImmobile {
                  titolo
                  testo
                }
              }
            }
          }
        }
      }
    }
  `);
  const handleInfoClick = (e) => {
    e.preventDefault();
    if (testiInformazioni?.classeEnergeticaImmobile?.testo?.length > 0) {
      setShowModalService(true);
    }
  };

  return (
    <>
      <div
        className={classNames(className, {
          [inputsStyles.selectAutocomplete]:
            type !== "BANCA" && type !== "STICKYBAR",
          [inputsStyles.selectAutocompleteBanca]: type === "BANCA",
          [inputsStyles.selectAutocompleteStickybar]: type === "STICKYBAR",
        })}
      >
        <label htmlFor="ClasseEnergetica">
          <span className={inputsStyles.classeEnergeticaLarge}>
            {/* Classe Energetica Imm. */}
            Classe Energetica
          </span>
          <span className={inputsStyles.classeEnergeticaSmall}>
            {/* Classe Energetica Immobile */}
            Classe Energetica
          </span>
          {testiInformazioni?.classeEnergeticaImmobile?.testo?.length > 0 && (
            <button
              onClick={(e) => handleInfoClick(e)}
              aria-label="informazioni sulla classe energetica dell'immobile"
            />
          )}
        </label>
        <CustomReactSelect
          selectCustom={selectCustom}
          inputId="ClasseEnergetica"
          options={options}
          name="ClasseEnergetica"
          aria-labelledby="ClasseEnergetica"
          defaultValue={fieldValue}
          value={fieldValue}
          onChange={(selectedOption) => {
            handleChange(selectedOption);
          }}
          className={classNames({
            "react-select-container-verde": type === "BANCA" || fromRicerca,
            "react-select-container": type !== "BANCA" && type !== "STICKYBAR",
            "react-select-container-stickybar": type === "STICKYBAR",
          })}
          classNamePrefix={classNames({
            "react-select-verde": type === "BANCA" || fromRicerca,
            "react-select": type !== "BANCA" && type !== "STICKYBAR",
            "react-select-stickybar": type === "STICKYBAR",
          })}
          fromRicerca={fromRicerca}
          type={type}
        />
      </div>
      {testiInformazioni?.classeEnergeticaImmobile?.testo?.length > 0 && (
        <ModalService
          show={showModalService}
          setShow={setShowModalService}
          title={
            testiInformazioni.classeEnergeticaImmobile.titolo || "Attenzione"
          }
          children={
            <div className={formRicercaStyles.text}>
              {parse(testiInformazioni.classeEnergeticaImmobile.testo)}
            </div>
          }
        />
      )}
    </>
  );
};

export default ClasseEnergetica;
